import { NavLink } from 'react-router-dom'
import { useState } from 'react'

import { BurguerMenuButton } from '../../../components/BurguerMenuButton'
import { DesktopMenu } from './DesktopMenu'
import { MobileMenu } from './MobileNavigation'
import { Medias } from '../../../enumns/medias'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { ReactComponent as LogoSvg } from '../../../assets/svgs/logo.svg'

export const Header = () => {
  const isDesktopSize = useMediaQuery(`(min-width: ${Medias.LG}px)`)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  return (
    <header className="flex items-center justify-between px-6 py-6 lg:px-14 lg:py-7 lg:border-b-2 lg:border-grey-300">
      <NavLink to="#">
        <LogoSvg className="h-10 w-28" />
      </NavLink>

      {isDesktopSize ? (
        <div className="ml-20 grow">
          <DesktopMenu />
        </div>
      ) : (
        <>
          <BurguerMenuButton onOpenMenu={() => setIsMobileMenuOpen(true)} />
          <MobileMenu
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
          />
        </>
      )}
    </header>
  )
}
